<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="false && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>

            <div class="list">
              <SearchConditions
                :device="device"
                @search="search"
              ></SearchConditions>

              <StockList
                class="stock-list"
                :deviceID="deviceID"
                :selectEvent="selectEvent"
                :searchCondition="searchCondition"
                :searchEvent="searchEvent"
              ></StockList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import TreeView from '@/components/include/TreeView';
import SearchConditions from '@/components/stock/SearchConditions';
import StockList from '@/components/stock/StockList';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    TreeView,
    SearchConditions,
    StockList,
  },
  data: () => ({
    menu: null,
    company: null,
    device: null,
    deviceID: '',
    selectEvent: 0,
    refreshEvent: 0,
    treeType: 'device',
    treeScope: 'biz',
    menuInfo: {
      mainTitle: 'Device',
      mainName: '재고 관리',
      subTitle: 'Stock',
      subName: '재고 관리',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    searchCondition: null,
    searchEvent: 0,
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type) {
      if (type === 'device') {
        this.company = null;
        this.device = object;
        this.deviceID = object.id;
        this.menuInfo.company = null;
        this.menuInfo.device = object;
        this.selectEvent ^= 1;
      } else if (type === 'company') {
        this.company = object;
        this.device = null;
        this.deviceID = '';
        this.menuInfo.company = object;
        this.menuInfo.device = null;
        this.selectEvent ^= 1;
      }
    },
    search(condition) {
      this.searchCondition = condition;
      this.searchEvent ^= 1;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/stock/Stock.vue